// @flow

import * as React from 'react';
import uiStore from 'stores/ui';
import { history } from '@insolus/react-router';
import staticRedirect from 'utils/staticRedirect';

type RedirectOptions = {
    static: boolean
};

type Returner = (url: string, options?: RedirectOptions) => () => void;

const useRedirect = (): Returner => React.useCallback(
    (url: string, options?: RedirectOptions = {}) => () => {
        if (uiStore.isStatic || options?.static) {
            staticRedirect(url);
            return;
        }

        history.push(url);
    },
    []
);

export default useRedirect;
